





















































































import { Component, Vue, Prop } from "vue-property-decorator";
import agreementTemplate from "@components/common/agreement/pageTemplate.vue";

@Component({
  components: {
    agreementTemplate
  }
})
export default class VATAgreementZH extends Vue {

  private companyName:string = ''

  private async mounted() {
    const result = await this.$light.dispatch('app/companyName')
    // console.log(this.$light.store)
    this.companyName = '杭州乒乓智能技术公司'
  }
}
